import { render, staticRenderFns } from "./SuccessScreenNudge.vue?vue&type=template&id=fb4dd92e&scoped=true"
import script from "./SuccessScreenNudge.vue?vue&type=script&lang=ts"
export * from "./SuccessScreenNudge.vue?vue&type=script&lang=ts"
import style0 from "./SuccessScreenNudge.vue?vue&type=style&index=0&id=fb4dd92e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4dd92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb4dd92e')) {
      api.createRecord('fb4dd92e', component.options)
    } else {
      api.reload('fb4dd92e', component.options)
    }
    module.hot.accept("./SuccessScreenNudge.vue?vue&type=template&id=fb4dd92e&scoped=true", function () {
      api.rerender('fb4dd92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/SuccessScreenNudge.vue"
export default component.exports